import { constants } from '@atc/bonnet-seo';
import { getReference } from '@atc/bonnet-reference';
import pageNames from './pageNames';
import funnels from './funnels';
import { formatTrimCode, getSingleMakeModelTrim } from './utils/pathQueryUtils';
const {
  FIND_CAR
} = funnels;
const {
  SEARCH_RESULTS
} = pageNames;
export default async function processPathname(_ref) {
  let {
    query,
    rawQueryData,
    pageName,
    pathname,
    brand,
    basePath
  } = _ref;
  // allowedPathSegments contains a list of segments found in reference data that contain the special characters.
  // the purpose of this array is to prevent the processor from removing special characters from valid urls
  // i.e: kia/soul/+;
  const allowedPathSegments = [];
  const {
    make,
    model,
    trim
  } = getSingleMakeModelTrim(rawQueryData);

  // regex for strings containing '+', '-', '_' ,' ' and !
  const trimsWithSpecialCharRgx = new RegExp(/([0-9a-zA-Z]*[+\-_\s!]+[0-9a-zA-Z]*)+$/);

  // trimCode(List) should be in the correct format '[MAKE]|[Trim Name]`
  const paramTrimCode = formatTrimCode(trim === null || trim === void 0 ? void 0 : trim.split('|')[1]);

  // if the query trimCode contains a special character, check reference data to verify its existence
  if (make && model && paramTrimCode && trimsWithSpecialCharRgx.test(trim)) {
    const {
      success,
      payload
    } = await getReference('trimCode', {
      makeCode: make.toUpperCase(),
      modelCode: model.toUpperCase()
    });
    if (success) {
      const trimPayload = payload.find(_ref2 => {
        let {
          code
        } = _ref2;
        return formatTrimCode(code) === paramTrimCode;
      });
      const trimCode = trimPayload === null || trimPayload === void 0 ? void 0 : trimPayload.code;
      if (trimCode) {
        allowedPathSegments.push(formatTrimCode(trimCode));
      }
    }
  }
  switch (pageName) {
    case SEARCH_RESULTS:
      {
        let listingTypeSuffix = '';
        if (brand === 'atc' || brand === 'carAndDriver') {
          // if the brand is ATC update any listingType parameter to include `-cars` suffix;
          // Note: the listingTypeSuffix is not used for CAR_AND_DRIVER
          if (brand === 'atc') {
            listingTypeSuffix = `-${constants.CARS}`;

            // update any listingType parameter to include `-cars` suffix;
            pathname = pathname.replace(/\/(new|used|certified|third-party-certified|all)(?=$|\/)/gi, `/$1${listingTypeSuffix}`);
          }
          // Applies to both ATC and CAR_AND_DRIVER
          // If the SRP path has a listingType encoded as a `used` segment (e.g.: '/used-car' for ATC, and '/used' for carAndDriver)
          // AND has any other seo pathname encoded, then
          // we remove the `used` segment as the other SEO param will allow the route to be directed to the SRP
          // Examples:
          // ATC: /cars-for-sale/used-cars/chevrolet => cars-for-sale/chevrolet
          // CAR_AND_DRIVER: /cars-for-sale/used/chevrolet => cars-for-sale/chevrolet
          const usedCarsSegment = `/used${listingTypeSuffix}`;
          const usedCarDefaultSegmentCount = basePath ? 3 : 2;
          if (pathname.includes(usedCarsSegment) && pathname.split('/').length > usedCarDefaultSegmentCount) {
            const re = new RegExp(usedCarsSegment);
            pathname = pathname.replace(re, '');
          }

          // remove listing types not allowed in seo section of the url - ensure it is just added as a query param
          const thirdPartySegment = `/third-party-certified${listingTypeSuffix}`;
          if (pathname.includes(thirdPartySegment)) {
            const re = new RegExp(thirdPartySegment);
            pathname = pathname.replace(re, '');
            query.listingType = ['3P_CERT'];
          }
        }

        // after all processing if the pathname is reduced to just the funnel name
        // then we append 'searchresults.xhtml' for backwards compatibility
        if (pathname === `/${FIND_CAR}`) {
          pathname = `/${FIND_CAR}/searchresults.xhtml`;
        }
        break;
      }
    default:
      break;
  }

  // final blunt force attempt to remove any remaining delimiter with a dash
  pathname = pathname.split('/').filter(e => e).reduce((acc, pathSegment) => {
    // Don't replace + with - in valid paths with special characters.
    if (allowedPathSegments.includes(pathSegment)) {
      return `${acc}/${pathSegment}`;
    }
    return `${acc}/${pathSegment.replace(/\+/g, '-')}`;
  }, '');
  return {
    query,
    pathname
  };
}